import * as React from "react";
function SvgCarGauge(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M25 23h5.95c0-.33.05-.66.05-1a15 15 0 00-30 0c0 .34 0 .67.05 1H7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path d="M21.53 14.15a1 1 0 00-1.38.32l-5.82 7.43a2 2 0 003.34 2.2l4.18-8.57a1 1 0 00-.32-1.38z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCarGauge);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
